module.exports = __webpack_public_path__ + "img/269.62b55901.jpg";